import { apiFetch } from '@ami/react/core';
import { CustomerApprovalFilter } from '../customer-approvals/customerApprovalFilter';

const _baseEndPoint = 'customer-approvals';

export default {
  search: async (filter = new CustomerApprovalFilter(), page) => {
    filter.setPaginationParameters(page);
    const result = await apiFetch(`${_baseEndPoint}?${filter.toQueryString()}`);
    return result;
  },
};
